import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AuthWrapper from './components/AuthWrapper';
import MainLayout from './components/Layout/MainLayout';
import LoginPage from './components/Pages/LoginPage';
import LibraryPage from './components/Pages/LibraryPage';
import ProcessBookPage from './components/Pages/ProcessBookPage';
import AccountPage from './components/Pages/AccountPage';
import CreditsPage from './components/Pages/CreditsPage';
import ImageGeneratorPage from './components/Pages/ImageGeneratorPage';
import BookReaderPage from './components/Pages/BookReaderPage';
import ExamplesPage from './components/Pages/ExamplesPage';
import TermsOfServicePage from './components/Pages/TermsOfServicePage';
import PrivacyPolicyPage from './components/Pages/PrivacyPolicyPage';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* Public login route */}
        <Route path="/login" element={<LoginPage />} />
        
        {/* Main app routes - wrapped in AuthWrapper which shows landing page or authenticated content */}
        <Route path="/*" element={
          <AuthWrapper>
            <MainLayout>
              <Routes>
                <Route path="/" element={<LibraryPage />} />
                <Route path="/process-book" element={<ProcessBookPage />} />
                <Route path="/process-book/:stage" element={<ProcessBookPage />} />
                <Route path="/examples" element={<ExamplesPage />} />
                <Route path="/credits" element={<CreditsPage />} />
                <Route path="/image-generator" element={<ImageGeneratorPage />} />
                <Route path="/book-reader" element={<BookReaderPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/terms" element={<TermsOfServicePage />} />
                <Route path="/privacy" element={<PrivacyPolicyPage />} />
              </Routes>
            </MainLayout>
          </AuthWrapper>
        } />
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
};

export default App; 